"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsePostOrderCreateRequestToJSON = exports.ResponsePostOrderCreateRequestFromJSONTyped = exports.ResponsePostOrderCreateRequestFromJSON = exports.instanceOfResponsePostOrderCreateRequest = void 0;
/**
 * Check if a given object implements the ResponsePostOrderCreateRequest interface.
 */
function instanceOfResponsePostOrderCreateRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "basketId" in value;
    return isInstance;
}
exports.instanceOfResponsePostOrderCreateRequest = instanceOfResponsePostOrderCreateRequest;
function ResponsePostOrderCreateRequestFromJSON(json) {
    return ResponsePostOrderCreateRequestFromJSONTyped(json, false);
}
exports.ResponsePostOrderCreateRequestFromJSON = ResponsePostOrderCreateRequestFromJSON;
function ResponsePostOrderCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'basketId': json['basketId'],
    };
}
exports.ResponsePostOrderCreateRequestFromJSONTyped = ResponsePostOrderCreateRequestFromJSONTyped;
function ResponsePostOrderCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'basketId': value.basketId,
    };
}
exports.ResponsePostOrderCreateRequestToJSON = ResponsePostOrderCreateRequestToJSON;
